import { toast } from '@blocksuite/affine-components/toast';
import {
  type BlockDeletionOptions,
  type BlockDeletionOutcome,
  deleteSelectedModelsCommand,
} from '@blocksuite/affine-shared/commands';
import { DocModeProvider } from '@blocksuite/affine-shared/services';
import type { BlockStdScope } from '@blocksuite/std';
import type { BlockModel } from '@blocksuite/store';

import { EdgelessCRUDIdentifier } from '../extensions/crud-identifier';

/**
 * Route block actions outside the editor to its canvas or page deletion gate.
 * A block the trash could not take is reported once: by the canvas gate
 * itself, on the page here.
 */
export function deleteBlocksThroughGate(
  std: BlockStdScope,
  models: BlockModel[],
  options: BlockDeletionOptions = {}
): Promise<BlockDeletionOutcome[]> {
  const crud =
    std.get(DocModeProvider).getEditorMode() === 'edgeless'
      ? std.get(EdgelessCRUDIdentifier)
      : null;
  return Promise.all(
    models.map(async model => {
      const canvasModel = crud?.getElementById(model.id);
      if (crud && canvasModel) {
        const [outcome] = await crud.deleteElements([canvasModel], options);
        return outcome ?? 'rejected';
      }
      const [, context] = std.command.exec(deleteSelectedModelsCommand, {
        selectedModels: [model],
        deleteOptions: options,
      });
      const [outcome = 'rejected'] = context?.deletionResults
        ? await context.deletionResults
        : [];
      if (outcome === 'rejected') {
        toast(std.host, 'Failed to move block to trash');
      }
      return outcome;
    })
  );
}
